import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Button, Col, Modal, Row } from "antd";

export const ModalRequerimiento = () => {
  const { catDocsPendientes } = useSelector((state) => state.expDigital);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible((state) => !state);
  };

  return (
    <div>
      <Modal
        title="Requerimientos de los documentos"
        visible={isModalVisible}
        onCancel={showModal}
        maskClosable={false}
        width={420}
        footer={null}
      >
        {catDocsPendientes.map((item, i) => (
          <Row key={i} style={{ marginBottom: 20 }}>
            <Col span={1} xxl={1} xl={1} lg={1} md={1} sm={24} xs={24}>
              <div className="exp-numero-requisito">{i + 1}</div>
            </Col>
            <Col span={23} xxl={23} xl={23} lg={23} md={23} sm={24} xs={24}>
              <div className="exp-req-docs">{item.nombreDocumento}</div>
              <div className="exp-req-descripcion">
                <div style={{ margin: "5px 6px 5px 6px" }}>
                  {item.descripcion}
                </div>
              </div>
            </Col>
          </Row>
        ))}
      </Modal>
      <Button
        type="primary"
        style={{ marginTop: 15, width: "100%" }}
        onClick={showModal}
      >
        Ver requerimientos de los documentos
      </Button>
    </div>
  );
};
